import React, { useCallback, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { fetchActiveTelemetry } from "../FieldApp/fieldAppApi";
import {
  buildFieldAppTrackingHref,
  inactiveTelemetryOperators,
} from "./dashboardActiveTelemetry";
import {
  fieldAlertDurationLabel,
  fieldAlertRelativeLabel,
  fieldAlertTimeOfDay,
} from "./dashboardFieldAlerts";
import "./DashboardActiveTelemetryKpi.css";

const POLL_MS = 5000;

function inactiveTelemetryMeta(operator, now, t) {
  const time = fieldAlertTimeOfDay(operator && operator.releasedAt);
  const relative = fieldAlertRelativeLabel(
    operator && operator.releasedAt,
    t,
    now
  );
  const machine = String(
    (operator && (operator.lastMachineIdent || operator.machineIdent)) || ""
  ).trim();
  const paused = operator && operator.reason === "pause";
  let base = paused
    ? t("deu pausa nos trabalhos")
    : machine
      ? t("finalizou a máquina {{machine}}", { machine })
      : t("finalizou a telemetria");
  if (time) base = t("{{message}} às {{time}}", { message: base, time });
  if (!paused && operator && operator.assumedAt && operator.releasedAt) {
    const duration = fieldAlertDurationLabel(
      operator.assumedAt,
      operator.releasedAt
    );
    if (duration) {
      base = t("{{message}} · ficou {{duration}}", {
        message: base,
        duration,
      });
    }
  }
  if (relative) base = t("{{message}} · {{relative}}", { message: base, relative });
  return base;
}

function DashboardInactiveTelemetryKpi({ farm_id, t }) {
  const history = useHistory();
  const [operators, setOperators] = useState([]);
  const [now, setNow] = useState(() => new Date());
  const [loading, setLoading] = useState(true);

  const loadOperators = useCallback(async () => {
    if (!farm_id) return;
    try {
      const data = await fetchActiveTelemetry(farm_id);
      setOperators(
        inactiveTelemetryOperators(
          data && data.sessions,
          data && data.releases
        )
      );
      setNow(new Date());
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [farm_id]);

  useEffect(() => {
    loadOperators();
    const timer = window.setInterval(loadOperators, POLL_MS);
    return () => window.clearInterval(timer);
  }, [loadOperators]);

  const openLastLocation = (operator) => {
    const href = buildFieldAppTrackingHref(farm_id, {
      operatorId: operator.operatorId,
      machineIdent: operator.lastMachineIdent || operator.machineIdent,
      assumedAt: operator.releasedAt,
    });
    if (href) history.push(href);
  };

  return (
    <div className="col-xs-12 col-md-3 col-lg-3 col-sm-6">
      <div className="x_panel no-margin-top dashboard-active-telemetry dashboard-active-telemetry--ended">
        <div className="dashboard-active-telemetry__header">
          {t("Telemetria encerrada")}
          {operators.length ? (
            <span className="dashboard-active-telemetry__count">
              {operators.length}
            </span>
          ) : null}
        </div>

        {loading ? (
          <p className="dashboard-active-telemetry__empty text-muted">
            {t("Carregando…")}
          </p>
        ) : operators.length === 0 ? (
          <p className="dashboard-active-telemetry__empty text-muted">
            {t("Ninguém encerrou a telemetria")}
          </p>
        ) : (
          <ul className="dashboard-active-telemetry__list">
            {operators.map((operator) => (
                <li
                  key={operator.operatorId}
                  className="dashboard-active-telemetry__item"
                >
                  <button
                    type="button"
                    className="dashboard-active-telemetry__name"
                    onClick={() => openLastLocation(operator)}
                    title={t("Abrir a última localização")}
                  >
                    {operator.operatorName}
                  </button>
                  <span className="dashboard-active-telemetry__meta">
                    {inactiveTelemetryMeta(operator, now, t)}
                  </span>
                </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default withTranslation()(DashboardInactiveTelemetryKpi);
